import React, {useState} from 'react';
import {Modal, Input, notification, Button, Spin} from 'antd';
import i18n from '../../../i18n';

export default function ModalRefuseCrossDock({isShow, setIsShow, setIsNeedUpdate, crossDockId, onRefuse}) {

  const {TextArea} = Input;
  const [loading, setLoading] = useState(false);
  const [refuseReason, setRefuseReason] = useState('');

  let bigButtonStyle = { width: '200px', height: '43px', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent" };

  const handleRefuse = () => {
    if (!refuseReason.trim()) {
      notification.warning({
        message: i18n.t('Отмена заявки'),
        description: i18n.t('Укажите причину отмены')
      });
      return;
    }

    setLoading(true);
    
    if (onRefuse) {
      onRefuse(refuseReason)
        .then(() => {
          setRefuseReason('');
          setIsShow(false);
        })
        .finally(() => setLoading(false));
    }
  };

  const handleCancel = () => {
    setRefuseReason('');
    setIsShow(false);
  };

  return (
    <Modal
      title={i18n.t('Отмена заявки')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={handleCancel}
      footer={[
        <Button 
          key="refuse" 
          disabled={!refuseReason.trim()} 
          onClick={handleRefuse} 
          style={bigButtonStyle}
          className="action-button typical-btn-red"
        >
          {i18n.t('Отменить заявку')}
        </Button>
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <div style={{marginBottom: '10px'}}>
          {i18n.t('Укажите причину отмены заявки')}:
        </div>
        <TextArea 
          rows={4} 
          onChange={e => setRefuseReason(e.target.value)} 
          value={refuseReason} 
          placeholder={i18n.t('Введите причину отмены')}
        />
      </Spin>
    </Modal>
  );

}